import Vue from "vue";
import Vuex from 'vuex';
import cities from './cities';
import home from "./home";
import agendDate from "./agendDate";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        cities,
        agendDate,
        home
    }
});

export default store;